/** Shared class names for the dashboard: warm grey canvas, raised cards, pills. */
export const dashboardStyles = {
  canvas: "bg-background",
  sidebar: "bg-background",
  mainPanel:
    "bg-card md:rounded-[1.5rem] md:shadow-[0_1px_0_rgba(0,0,0,0.03)]",
  softShadow: "shadow-none",
  kpiGridWrapper: "bg-transparent border-none p-0 shadow-none",
  sectionCard:
    "p-5 sm:p-6 border border-border shadow-none rounded-[1.25rem] bg-card",
  listSectionCard:
    "p-5 sm:p-6 flex flex-col gap-3 border border-border shadow-none rounded-[1.25rem] bg-card",
  listContainer: "space-y-2",
  listItem:
    "flex items-center justify-between px-3.5 py-3 rounded-2xl cursor-pointer bg-muted hover:bg-accent transition-colors border border-transparent group",
  listItemMuted:
    "flex items-center justify-between px-3.5 py-3 rounded-2xl bg-muted hover:bg-accent transition-colors border border-transparent group",
  listItemIcon:
    "w-9 h-9 bg-card rounded-xl flex items-center justify-center shrink-0 border border-border",
  listItemIconSvg: "h-4 w-4 text-primary",
  sectionTitle: "text-[15px] font-heading font-bold tracking-tight text-foreground",
  sectionSubtitle: "text-xs font-medium text-muted-foreground",
  statTile: "rounded-2xl bg-muted p-3.5 space-y-0.5",
  statTileLabel:
    "text-[11px] font-medium text-muted-foreground",
  statTileValue: "text-lg font-bold font-heading tabular-nums text-foreground",
  emptyIcon:
    "w-12 h-12 rounded-2xl bg-muted ring-1 ring-inset ring-foreground/10 flex items-center justify-center mb-3.5 text-muted-foreground [&>svg]:h-5 [&>svg]:w-5",
  emptyTitle: "text-[15px] font-heading font-bold tracking-tight mb-1",
  emptyDescription:
    "text-[13px] font-medium text-muted-foreground text-center mb-4 max-w-[280px] leading-relaxed",
  filterCard:
    "p-4 border border-border shadow-none rounded-[1.25rem] bg-card",
  navButton:
    "h-10 w-full mb-0.5 justify-start gap-2.5 rounded-full !py-0 text-[14px] font-medium !shadow-none hover:!scale-[1.00]",
  navLink:
    "group flex h-9 w-full items-center gap-2.5 rounded-full px-3 text-[14px] font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary/30",
  navActive:
    "bg-highlight font-semibold text-primary hover:bg-highlight hover:text-primary",
  navIdle:
    "text-muted-foreground hover:bg-foreground/[0.06] hover:text-foreground",
  pillTrigger:
    "h-9 rounded-full border border-border bg-card px-3.5 text-xs font-semibold text-foreground shadow-none",
  tableWrap: "overflow-hidden rounded-[1.25rem] border border-border",
  filterInput:
    "h-10 rounded-full border-border bg-muted pl-9 shadow-none text-sm text-foreground focus-visible:ring-primary/20",
  filterSelect:
    "h-10 rounded-full border-border bg-muted shadow-none text-sm text-foreground",
  paginationBar:
    "flex items-center justify-between gap-3 pt-4 text-sm text-muted-foreground",
  paginationBtn:
    "h-9 rounded-full border-border px-4 font-semibold shadow-none",
  badge:
    "rounded-full border-0 px-2.5 py-0.5 text-xs font-medium",
  iconChipPrimary: "bg-primary text-primary-foreground",
  iconChipLavender: "bg-secondary text-secondary-foreground",
  iconChipWarm: "bg-muted text-primary",
  iconChipSage: "bg-[#d2e4c4] text-[#2a0e5c]",
} as const;
